<template>
  <router-layout>
    <div class="app-container" style="min-width:320px;max-width:600px;position:relative;margin-left:auto;margin-right:auto;background:#ffffff;">
        <div class="app-header">
          <div id="header_return" class="header_return" style="padding-top:5px;"><button @click="exitPlayer" class="exitBtn">退出</button></div>
          <div class="header_title" style="text-align:center;margin-right:60px;">{{playinfo.album_list[currentItemIndex].title}}</div>
          <div id="header_right" class="header_right" style="padding-right:10px;padding-top:5px;"><button @click="shrinkPlayer" class="shrinkBtn">最小化</button></div>
        </div>

        <div id="video-content" class="app-content" style="bottom:0;" >
            <!--音频封面-->
            <div style="position:relative;text-align:center;padding-top:20px;">
                <div class="circular_landscape">
                    <img :src="playinfo.album_cover" />
                </div>
                <div style="text-align:left;font-size:18px;font-weight:bold;color:#333333;padding:10px;">
                 【 {{playinfo.album_title}}】
                </div>
                <div style="text-align:left;font-size:14px;color:#333333;padding:0 20px;">
                  作者：{{playinfo.album_author}}
                </div>
              
            </div>
            <!-- 播放进度条 -->
            <div class="time-box">
                <div class="time">
                    <span class="time-l">{{currentTime}}</span>
                    <progressBar style="overflow:hidden" :percent="percent" @percentChange="percentChange"></progressBar>
                    <span class="time-r">{{ duration }}</span>
                </div>
            </div>
             <!-- 播放控制条 -->
            <div class="player-controls">
                <span @click="prevTrack"><img src="../../assets/images/player/prev.png"/></span>
                <span>
                    <img  @click="play" id="playButton" src="../../assets/images/player/pause.png"  v-show="audio!=null && !audio.paused && isLoaded"/>
                    <img  @click="play" id="playButton" src="../../assets/images/player/play.png" v-show="audio!=null && audio.paused && isLoaded"/>
                    <div id="preloader" v-show="!isLoaded"></div>
                </span>
                <span @click="nextTrack"><img src="../../assets/images/player/next.png"/></span>
            </div>
        </div>
    </div>
  </router-layout>
</template>
<script>
import progressBar from "../../components/ProgressBar";
export default {
    name: "Player",
    data() {
        return {
            title:"",
            urlRoot:this.$store.state.urlRoot,
            apiRoot:this.$store.state.apiRoot,
            audio:null,
            duration: null,
            currentTime: null,
            percent:0,
            isPlaying: false,
            isLoaded:false,
            canListen:true,
            playinfo:this.$store.state.playinfo,
            currentItemIndex:this.$store.state.playinfo.currentIndex,
        };
    },
    watch:{
       isAlbumChanged(newVal, oldVal){
          this.playinfo=this.$store.state.playinfo
          this.currentItemIndex=this.$store.state.playinfo.currentIndex
          this.resetPlayer()
       }
    },
    created(){
        this.initAudio()
    },
    computed: {
      isAlbumChanged(){
         return `${this.$store.state.playinfo.album_id},${this.$store.state.playinfo.currentIndex}`
      }
    },
    destroyed () {
        this.audio=null;
    },
    methods:{
        initAudio(){
            let _this = this;
     
            if(this.audio==null){
                this.audio=new Audio() 
            }
            this.audio.crossOrigin = this.anonymous;
            this.audio.ontimeupdate = function() {
              _this.generateTime();
            };
            this.audio.onloadedmetadata = function() {
              _this.generateTime();
            };
            this.audio.oncanplaythrough=function(){
              _this.isLoaded=true
            };
            this.audio.onended = function() {
              _this.nextTrack();
            };

        },
        shrinkPlayer(){        
          this.$emit('shrinkPlayer')
        },
        exitPlayer(){
          this.audio.pause()
          this.audio=null
          this.$store.dispatch('updatePlayState',false)
          this.$emit('shrinkPlayer')
        },
        initPlay(){
          if(this.audio==null){
            this.initAudio()
          }
          if(this.audio.src==''){
              this.audio.src = this.playinfo.album_list[this.currentItemIndex].source;
              this.play()
          }
        },
        play() {
          if (this.audio.paused) {
            this.audio.play();
          } else {
            this.audio.pause();
          }
        },
        generateTime() {
          if(this.audio==null) return
          let durmin = Math.floor(this.audio.duration / 60);
          let dursec = Math.floor(this.audio.duration - durmin * 60);
          let curmin = Math.floor(this.audio.currentTime / 60);
          let cursec = Math.floor(this.audio.currentTime - curmin * 60);
          if (durmin < 10) {
            durmin = "0" + durmin;
          }
          if (dursec < 10) {
            dursec = "0" + dursec;
          }
          if (curmin < 10) {
            curmin = "0" + curmin;
          }
          if (cursec < 10) {
            cursec = "0" + cursec;
          }
      
          this.percent=this.audio.currentTime / this.audio.duration;
          this.duration = durmin + ":" + dursec;
          this.currentTime = curmin + ":" + cursec;
          if(this.percent>=0.5 && this.canListen && this.$store.state.playControl.isPayable && !this.$store.state.playControl.isMember){
              this.canListen=false
              this.audio.pause();
              this.confirm();
              return;
          }
        },
        percentChange(precent) {
          const currentTime = this.audio.duration * precent;
          this.audio.currentTime = currentTime;
        },
        prevTrack() {
          if (this.currentItemIndex > 0) {
            this.currentItemIndex--;
          } else {
            this.currentItemIndex = this.playinfo.album_list.length - 1;
          }
          this.$store.dispatch('updatePlayIndex',this.currentItemIndex)
          this.resetPlayer();
        },
        nextTrack() {
          if (this.currentItemIndex < this.playinfo.album_list.length - 1) {
            this.currentItemIndex++;
          } else {
            this.currentItemIndex = 0;
          }
          this.$store.dispatch('updatePlayIndex',this.currentItemIndex)
          this.resetPlayer();
        },
        resetPlayer() {
          let _this=this
          this.audio.currentTime = 0;
          this.audio.src = this.playinfo.album_list[this.currentItemIndex].source;
          this.$nextTick(() => {
            _this.audio.play();
          })
        
        },
        confirm() {
          //确认弹窗
          let options = {
          title: "提示信息",
          message: "本产品为付费产品，您已试听50%，如想收听全部，请直接购买",
          options: {
              yesCallbackFunction: this.yesCallbackFunction,
              noCallbackFunction: this.noCallbackFunction,
              yesText:'购买',
              noText:'',
              data: {
                test: '111'
              }
          }
          }
          this.$installdialog.confirm(options);
        },
        yesCallbackFunction(){
          this.canListen=true
          this.buy()
        },
        noCallbackFunction(){
          this.canListen=true
        },
        buy(){
          if(this.$store.state.userinfo.isLogin!='1'){
                this.shrinkPlayer()
                this.$toast.bottom('请您登录后购买')
                this.$router.push('/user/login')
                return;
          }
          this.exitPlayer()     
          let _this = this;
          this.$loading.open('正在处理...')
          this.$api.post(this.apiRoot+'/app/jvideo_submitOrder.action', {
              "id":_this.playinfo.album_id,"memberID":_this.$store.state.userinfo.memberID,"type":'lesson'
              }, response => {
              if(response.status >= 200 && response.status < 300) {
                  if(response.data.err_msg=='success'){
                      let order=response.data.order
                     _this.$router.replace({path:'/order/media',query:{orderNo:order.orderNo}})
                  }else{
                      _this.$toast.bottom('订单提交失败')
                  }
              }
              _this.$loading.close();
          });         
        },
        checkBrowse(){
            var ua = navigator.userAgent.toLowerCase()
            var isWeixin = ua.indexOf('micromessenger') != -1
            return isWeixin
        },
        checkApple(){
            var isApple=(navigator.userAgent.indexOf('iPhone') != -1) || (navigator.userAgent.indexOf('iPod') != -1) ||(navigator.userAgent.indexOf('iPad') != -1)
            return isApple
        }
    },
    components:{
      progressBar
    },
};
</script>

<style lang="scss" scoped>

    #header_return .exitBtn{
        width:50px;height:100%;border:none;outline:none;background:#fff;padding-top:10px;
        background-image: url('../../assets/images/player/exit.png');font-size:12px;color:#333333;font-weight:bold;
        background-repeat: no-repeat;background-position:center top;background-size:18px 18px;
    }
    #header_right .shrinkBtn{
        width:55px;height:100%;border:none;outline:none;background:#fff;padding-top:10px;
        background-image: url('../../assets/images/player/min.png');font-size:12px;color:#333333;font-weight:bold;
        background-repeat: no-repeat;background-position: center top;background-size:18px 18px;
    }
    /*播放器 */
    .time-box {width: 100%;height:30px;margin-top:20px;padding:20px 0;}
    .time {width: 100%;height:30px;margin: auto;display: flex;justify-content: space-between;}
    .time span {display: inline-block;width:60px;height: 30px;line-height: 30px;color:#666666;font-size: 14px;font-weight: bold;}
    .time-l {padding:0 10px;text-align: left;}
    .time-r {padding:0 10px; text-align: right;}

    .player-controls {
        width: 100%;height: 60px;margin-top:20px;padding: 0 40px;box-sizing: border-box;line-height: 60px;
        display: flex;justify-content: space-between;background: #ffffff;z-index:500;
    }
    .player-controls img {width: 35px;height:35px;vertical-align: middle;}
    #playButton {width:45px;height:45px;}

    #preloader{
        position:relative;
        width:14px;
        height:14px;
        margin-top:24px;
        background:#F9AA50;
        border-radius:15px;
        animation: preloader 1.5s infinite linear;
    }
    #preloader:after{
        position:absolute;
        width:40px;
        height:40px;
        border-top:2px solid #f7dfb3;
        border-bottom:2px solid #F9AA50;
        border-left:2px solid transparent;
        border-right:2px solid transparent;
        border-radius:40px;
        content:'';
        top:-14px;
        left:-15px;
        animation: preloader_after 1.5s infinite linear;
    }
    @keyframes preloader {
        0% {transform: rotate(0deg);}
        50% {transform: rotate(180deg);background:#f7dfb3;}
        100% {transform: rotate(360deg);}
    }
    @keyframes preloader_after {
        0% {border-top:2px solid #f7dfb3;border-bottom:2px solid #f7dfb3;}
        50% {border-top:2px solid #F9AA50;border-bottom:2px solid #F9AA50;}
        100% {border-top:2px solid #f7dfb3;border-bottom:2px solid #f7dfb3;}
    }

  .circular_landscape{
      display:inline-block;position:relative;
      width:200px;height:200px;overflow:hidden;border-radius:50%;
  }
  .circular_landscape img{
      width:400px;height:200px;
  }
  /*无限旋转动画*/
		@keyframes changDeg{
			0%{transform: rotate(0deg);}
			100%{transform: rotate(360deg);}
		}
		.landscape_rotate{
			animation:changDeg 5s linear 0.5s infinite;
		}

</style>


// WEBPACK FOOTER //
// src/views/lesson/Player.vue